import React from "react"
import AnalyzerResources from "./analyzerResources"
import AnalyzerArchitecture from "./analyzerArchitecture"
import AskQuestion from "../app-components/ask-question"
/**
 * @param props {{
 *  scState:scState
 * }}
 */

export default function LeftSide({ scState }) {
  return (
    scState.showArchitecture && window["config"].SHOW_ARCHITECTURE == "YES") ? <AnalyzerArchitecture scState={scState}/>
    : scState.showAI ? <AskQuestion scState={scState}/>
    : 
    // default
    <AnalyzerResources scState={scState} />
}
